import { __read, __spread } from "tslib";
import { getScaleTicks, getScaleCenterPosition, } from '@keen.io/charts-utils';
export var AxisType;
(function (AxisType) {
    AxisType["X"] = "x";
    AxisType["Y"] = "y";
})(AxisType || (AxisType = {}));
var LINE_ADJUSTMENT = 0.5;
export var calculateVerticalLines = function (_a, _b) {
    var width = _a.width, height = _a.height;
    var top = _b.top, bottom = _b.bottom, left = _b.left, right = _b.right;
    return [
        {
            x1: left,
            x2: left,
            y2: height - bottom + LINE_ADJUSTMENT,
            y1: top - LINE_ADJUSTMENT,
        },
        {
            x1: width - right,
            x2: width - right,
            y2: height - bottom + LINE_ADJUSTMENT,
            y1: top - LINE_ADJUSTMENT,
        },
    ];
};
export var calculateHorizontalLines = function (_a, _b) {
    var width = _a.width, height = _a.height;
    var top = _b.top, bottom = _b.bottom, left = _b.left, right = _b.right;
    return [
        {
            x1: left - LINE_ADJUSTMENT,
            x2: width - right + LINE_ADJUSTMENT,
            y2: top,
            y1: top,
        },
        {
            x1: left - LINE_ADJUSTMENT,
            x2: width - right + LINE_ADJUSTMENT,
            y2: height - bottom,
            y1: height - bottom,
        },
    ];
};
export var generateGridLines = function (_a) {
    var scale = _a.scale, scaleSettings = _a.scaleSettings, dimension = _a.dimension, margins = _a.margins, axisType = _a.axisType;
    var closeLines = false;
    var calculatePosition;
    var values = getScaleTicks(scale, scaleSettings).ticks;
    if ('bandwidth' in scale) {
        calculatePosition = getScaleCenterPosition(scale);
        closeLines = true;
    }
    else {
        calculatePosition = scale;
    }
    var lines = [];
    if (axisType === AxisType.X) {
        values.forEach(function (value) {
            var y1 = 0 + margins.top;
            var y2 = dimension.height - margins.bottom;
            var x = calculatePosition(value);
            var isZero = value === 0;
            lines.push({
                x1: x,
                y1: y1,
                x2: x,
                y2: y2,
                stroke: isZero ? 2 : undefined,
            });
        });
        closeLines && lines.push.apply(lines, __spread(calculateVerticalLines(dimension, margins)));
    }
    else {
        values.forEach(function (value) {
            var y = calculatePosition(value);
            var isZero = value === 0;
            lines.push({
                x1: margins.left,
                y1: y,
                x2: dimension.width - margins.right,
                y2: y,
                stroke: isZero ? 2 : undefined,
            });
        });
        closeLines && lines.push.apply(lines, __spread(calculateHorizontalLines(dimension, margins)));
    }
    return lines;
};
